// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1hSX4","requiredAsterisk":"Info_requiredAsterisk__21rP_"};